import { Box, Link, List, ListItem, Typography } from '@mui/material';
import { FC } from 'react';

export const Step2Stripe: FC = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				mt: '20px',
				gap: '40px',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					backgroundColor: '#0092de24',
					borderRadius: '12px',
					p: '20px',
					width: 'calc(100%)',
				}}
			>
				<Typography
					sx={{
						fontSize: '3rem',
						color: '#016193',
						fontFamily: 'monospace',
						mr: 2,
						mt: -1,
						mb: -2,
						fontWeight: 'bold',
						textTransform: 'lowercase',
					}}
				>
					i
				</Typography>
				<Box>
					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}
					>
						Before moving forward, please ensure to thoroughly read the instructions provided in our
						help centre article{' '}
						<Link
							href="https://help.easproject.com/hc/en-gb/articles/6289572538271-How-to-issue-a-Stripe-restricted-key"
							target="_blank"
							rel="noreferrer"
							sx={{
								color: '#016193',
								fontSize: '1rem',
								fontWeight: 'bold',
								textDecoration: 'none',
								'&:hover': {
									textDecoration: 'underline',
								},
							}}
						>
							How to Generate a Stripe API Key for direct integration
						</Link>{' '}
						and prepare all necessary information.
					</Typography>

					<Typography
						component="div"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193', mt: 2 }}
					>
						On next step you will be requested for the information:
						<List dense>
							<ListItem>
								<b>Stripe Account description</b>&nbsp;(Will be displayed in the list of active
								integrations);
							</ListItem>
							<ListItem>
								<b>API Key </b>&nbsp;(step 6 of the instruction);
							</ListItem>
							<ListItem sx={{ display: 'inline-block' }}>
								<b>HS code</b>&nbsp;applicable for most of your products. You can get HS code
								from&nbsp;
								<Link
									href="https://easproject.com/eu-customs-tariffs-guide/"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									EAS EU Tariffs Guide
								</Link>
								.
							</ListItem>
						</List>
					</Typography>
				</Box>
			</Box>
		</Box>
	);
};
